import { render, staticRenderFns } from "./DupsView.vue?vue&type=template&id=9e1e75ea&"
import script from "./DupsView.vue?vue&type=script&lang=js&"
export * from "./DupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports